.ZaiPrePromptLink {
  .ZaiTagButton {
    width: auto;

    &:hover {
      box-shadow: none;
    }
  }
}
